export var MultipleChoiceType;
(function (MultipleChoiceType) {
    MultipleChoiceType["Unique"] = "unique";
    MultipleChoiceType["Multiple"] = "multiple";
})(MultipleChoiceType || (MultipleChoiceType = {}));
//# sourceMappingURL=MultipleChoice.js.map